import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon } = colorsPalettes;

export const Container = styled(FlexRow)`
    align-items: center;
    justify-content: space-between;
    position: relative;
`;
export const Title = styled.p`
    ${setFontVariant("subtitle2", carbon[400])};
    margin: 0;
    align-items: center;
    white-space: nowrap;
`;
export const TitleContainer = styled(FlexRow)`
    align-items: center;
    gap: 8px;
`;

export const IconButtonWrapper = styled.a`
    cursor: pointer;
    position: absolute;
    right: 0;
`;
